require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2009-06-05-leaving-nyc-jfk.json") })
        }
      }, "path---articles-2009-06-05-leaving-nyc-jfk");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2009-06-05-leaving-nyc-jfk!./.cache/json/articles-2009-06-05-leaving-nyc-jfk.json
// module id = 567
// module chunks = 231608221292675